export const dataOriginTypes = {
  API: "API",
  EXAMPLE_1: "example 1",
  EXAMPLE_2: "example 2",
  EXAMPLE_3: "example 3",
  EXAMPLE_4: "example 4",
  EXAMPLE_5: "example 5",
  EXAMPLE_6: "example 6",
  EXAMPLE_7: "example 7",
  EXAMPLE_8: "example 8",
  EXAMPLE_9: "example 9",
  NO_DATA: "no data",
};
